import React from "react";
import "./nav.css";
import { AiOutlineHome } from "react-icons/ai";
import { AiOutlineUser } from "react-icons/ai";
import { BiBook } from "react-icons/bi";
import { RiServiceLine } from "react-icons/ri";
import { BiMessageSquareDetail } from "react-icons/bi";
import { Link } from "react-scroll";

function Nav() {
  return (
    <nav>
      <Link href="#home" smooth spy to="home">
        <AiOutlineHome />
      </Link>
      <Link href="#about" smooth spy to="about">
        <AiOutlineUser />
      </Link>
      <Link href="#experience" smooth spy to="experience">
        <BiBook />
      </Link>
      <Link href="#portfolio" smooth spy to="portfolio">
        <RiServiceLine />
      </Link>
      <Link href="#contact" smooth spy to="contact">
        <BiMessageSquareDetail />
      </Link>
    </nav>
  );
}

export default Nav;
